import React, { useState, lazy, Component } from 'react';
import { ChevronDownIcon, ChevronUpIcon, ChevronRightIcon } from 'lucide-react';
// Type for the banks
type Bank = {
  name: string;
  short: string;
  logoUrl: string;
};
// Component for showing a bank logo
function LogoTile({
  bank,
  size = 'md'
}: {
  bank: Bank;
  size?: 'sm' | 'md';
}) {
  const boxClass = size === 'sm' ? 'bg-[#F5F7FA] h-12 w-24 rounded-lg flex items-center justify-center p-1.5' : 'bg-[#F5F7FA] h-20 w-40 rounded-xl flex items-center justify-center p-3';
  const imgClass = size === 'sm' ? 'max-h-8 max-w-full object-contain' : 'max-h-10 max-w-full object-contain';
  return <div className={`${boxClass} text-gray-500 relative overflow-hidden`} data-id="element-1216">
      <img src={bank.logoUrl} alt={bank.name} className={imgClass} loading="lazy" onError={e => {
      // Fallback with initials if image fails to load
      const target = e.target as HTMLImageElement;
      target.style.display = 'none';
      target.parentElement?.querySelector('.fallback-text')?.classList.remove('hidden');
    }} data-id="element-1217" />
      <div className="fallback-text hidden flex items-center justify-center w-full h-full" data-id="element-1218">
        <span className="text-xs md:text-sm font-semibold text-[#0E1113]" data-id="element-1219">
          {bank.short}
        </span>
      </div>
    </div>;
}
export function Logos() {
  // Sección completamente oculta
  return null;
}